import { IColumn } from '../../../components';

export const HistoricalKpiColumns: IColumn[] = [
  {
    id: 'kpi',
    name: '',
    width: '50%',
  },
  {
    id: 'avedaSalonData',
    name: 'Salon Data',
    width: '50%',
  },
] as const;
